<template>
  <div id="videoCardsComponent" class="scroll-parent-element-component horizontal-scroll-component" :data-brand="this.$store.state.chosenBrand">
    <div id="videoCardsHorizontalScroll" class="scroll-parent-element scroll-parent" data-has-scrollbar="true" data-scroll-region="min">
      <div class="scroll-horizontal">
        <div
          class="video-card"
          v-for="(card, index) in activeVideoCards"
          :key="index"
        >
          <video
            class="video lazyload"
            :src="card.videoUrl"
            muted
            loop
            playsinline
          ></video>

          <button class="play-btn">
            <svg class="icon-play" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <polygon points="5,3 19,12 5,21" fill="white"/>
            </svg>
            <svg class="icon-pause" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <rect x="6" y="4" width="4" height="16" fill="white"/>
              <rect x="14" y="4" width="4" height="16" fill="white"/>
            </svg>
          </button>

          <div class="video-card-overlay">
            <h3 class="video-card-title">{{ card.title }}</h3>

            <a
              class="sokal-link sokal-link-secondary dark-theme"
              :href="card.link"
            >
              <div class="sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-start">
                <span class="sokal-link-copy">{{ card.linkText }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="1.13em" height="1.6em"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="scroll-overlay scroll-overlay--left"></div>
      <div class="scroll-overlay scroll-overlay--right"></div>
      <div class="scroll-nav scroll-nav--left">
          <button type="button" class="scroll-nav-btn" data-scroll-parent="#videoCardsHorizontalScroll" data-direction="left" tabindex="0"></button>
      </div>
      <div class="scroll-nav scroll-nav--right">
          <button type="button" class="scroll-nav-btn" data-scroll-parent="#videoCardsHorizontalScroll" data-direction="right" tabindex="0"></button>
      </div>
    </div>
  </div>
</template>

<script>

  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";

  export default {
    data() {
      return {
        videoCards: {
          ford: {
            slot1: {
              title: "FUEL EFFICIENT",
              videoUrl: "https://player.vimeo.com/progressive_redirect/playback/1138952172/rendition/1080p/file.mp4?loc=external&signature=bf49fdb257b04f568b9b36a5dd49a7ec404a63a6e5e4f1e813cec68a42f28312",
              linkText: "View Inventory",
            },
            slot2: {
              title: "FAMILY FRIENDLY",
              videoUrl: "https://player.vimeo.com/progressive_redirect/playback/1138959351/rendition/1080p/file.mp4?loc=external&signature=7a893bad94e437d2159f988aadc763ca4fc75d884b452be24e690d2a3e9f3062",
              linkText: "View Inventory",
            },
            slot3: {
              title: "ALL WHEEL DRIVE",
              videoUrl: "https://player.vimeo.com/progressive_redirect/playback/1138955521/rendition/720p/file.mp4?loc=external&signature=2146784f1e558be53429b72c9149a53ba9eecccb352245aab5d09a3bd4f34097",
              linkText: "View Inventory",
            }
          },
          cjdr: {
            slot1: {
              title: "AMERICAN MUSCLE",
              videoUrl: "https://player.vimeo.com/progressive_redirect/playback/1166791359/rendition/1080p/file.mp4%20%281080p%29.mp4?loc=external&signature=b5fc16c2ebac229fede881fa44bc62441141abe1df59aa0d3be82c8c68ff6bc6",
              linkText: "View Inventory",
            },
            slot2: {
              title: "FAMILY FRIENDLY",
              videoUrl: "https://player.vimeo.com/progressive_redirect/playback/1166791330/rendition/1080p/file.mp4%20%281080p%29.mp4?loc=external&signature=a458ec1d24e27f4864b08e49843dee992da2f715b50546c2cb3b7b9325dea3b9",
              linkText: "View Inventory",
            },
            slot3: {
              title: "POWER & CAPABILITY",
              videoUrl: "https://player.vimeo.com/progressive_redirect/playback/1166791375/rendition/1080p/file.mp4%20%281080p%29.mp4?loc=external&signature=651f6be9dea6333ee5bc86d266fb78a4e21ccb1e0e5c100af3113f0627f61767",
              linkText: "View Inventory",
            }
          }
        }
      }
    },
    computed: {
      brand() {
        return this.$store.state.chosenBrand;
      },

      // 2. optional: formatted brand for display if needed
      formattedBrand() {
        if (!this.brand || this.brand.toLowerCase() === "none") {
          return "Default";
        }

        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      },

      activeVideoCards() {
        const slots = this.videoCards[this.brand] || {};

        return ["slot1", "slot2", "slot3"]
          .map(slot => slots[slot])
          .filter(Boolean);
      }
    },
    mounted() {
      (function($){
        const scrollElements = {
          init: function() {

            scrollElements.scrollNavInit();

            $('#videoCardsComponent .scroll-parent').each(function(){
              
              let parent = '#' + $(this).attr('id');
              let element = parent + ' .scroll-horizontal';
              
              scrollElements.setDataRegion(parent, element);
              scrollElements.setDataHasScrollbar(parent, element);

              $(window).resize(function(){
                scrollElements.setDataHasScrollbar(parent, element);
              })
              
              $(element).on('scroll', function(){
                scrollElements.setDataRegion(parent, element);
              })

            })

            $('#videoCardsComponent [data-toggle="tab"]').click(function(){
              setTimeout(function(){
                $('#videoCardsComponent .tab-content .scroll-parent').each(function(){
                  let parent = '#' + $(this).attr('id');
                  let element = parent + ' .scroll-horizontal';
                  scrollElements.setDataHasScrollbar(parent, element);
                });
              }, 220);
            });

          }, 

          scrollNavInit: function() {
            
            $('#videoCardsComponent .scroll-parent .scroll-nav').click(function(){

              $(this).find('.scroll-nav-btn').focus();
              
              let scrollParent = $(this).find('.scroll-nav-btn').attr('data-scroll-parent');
              let scrollTarget = scrollParent + ' .scroll-horizontal';
              let scrollContent = scrollTarget + ' > *';
              let distance = 0;

              $(scrollContent).each(function(){
                if ($(this).outerWidth() > distance) {
                  distance = $(this).outerWidth();
                }
              })
              
              let currentPosition = scrollElements.getPosition(scrollTarget);

              if ($(this).find('.scroll-nav-btn').attr('data-direction') === 'right') {
                scrollElements.animateScroll(scrollParent, scrollTarget, distance, currentPosition + distance);
              } else {
                scrollElements.animateScroll(scrollParent, scrollTarget, distance, currentPosition - distance);
              }
              
            })
          },

          setDuration: function(distance) {
            return Math.floor(distance / 0.7);
          }, 

          animateScroll: function(parent, element, distance, newPosition) {
            
            $(element).animate({
                scrollLeft: newPosition
            }, scrollElements.setDuration(distance));

            setTimeout(function(){
              scrollElements.setDataRegion(parent, element);
            }, scrollElements.setDuration(distance));
            
          }, 

          getPosition: function(element) {
            return $(element).scrollLeft();
          }, 

          getMaxScroll: function(element) {
            return document.querySelector(element).scrollWidth - (document.querySelector(element).clientWidth + 10);
          }, 

          setDataRegion: function(parent, element) {
            let maxScroll = scrollElements.getMaxScroll(element);
            let currentPosition = scrollElements.getPosition(element);

            if (currentPosition === 0 && maxScroll < 0) {
              $(parent).attr('data-scroll-region', 'min');
            } else if (currentPosition >= maxScroll) {
              $(parent).attr('data-scroll-region', 'max');
            } else if (currentPosition === 0) {
              $(parent).attr('data-scroll-region', 'min');
            } else {
              $(parent).attr('data-scroll-region', 'middle');
            }
          }, 

          setDataHasScrollbar: function(parent, element) {
            if (scrollElements.getPosition(element) === 0 && scrollElements.getMaxScroll(element) <= 0) {
              $(parent).attr('data-has-scrollbar', 'false');
            } else {
              $(parent).attr('data-has-scrollbar', 'true');
            }
          }
        }

        $(document).ready(scrollElements.init);

      })(jQuery)

      const isMobile = window.innerWidth <= 1199;

      // Select all video cards
      const cards = document.querySelectorAll(".video-card");

      cards.forEach((card) => {
        const video = card.querySelector(".video");
        const playBtn = card.querySelector(".play-btn");
        const iconPlay = playBtn.querySelector(".icon-play");
        const iconPause = playBtn.querySelector(".icon-pause");

        // Initial state: show play icon
        iconPlay.style.opacity = "1";
        iconPause.style.opacity = "0";

        // --- Intersection Observer for autoplay on scroll ---
        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (video.paused) {
                video.play().catch(() => {});
                iconPlay.style.opacity = "0";
                iconPause.style.opacity = "1";
              }
              obs.unobserve(video); // only trigger once per video
            }
          });
        }, { threshold: 0.25 }); // 25% visible triggers playback

        observer.observe(video);

        // --- Desktop hover behavior (optional) ---
        if (!isMobile) {
          card.addEventListener("mouseenter", () => {
            if (video.paused) {
              video.play().catch(() => {});
              iconPlay.style.opacity = "0";
              iconPause.style.opacity = "1";
            }
          });
        }

        // --- Play/Pause button ---
        playBtn.addEventListener("click", (e) => {
          e.stopPropagation();

          if (video.paused) {
            video.play().catch(() => {});
            iconPlay.style.opacity = "0";
            iconPause.style.opacity = "1";
          } else {
            video.pause();
            iconPlay.style.opacity = "1";
            iconPause.style.opacity = "0";
          }
        });
      });
    }
  }
</script>

<style scoped>
  .sokal-link {
    color: #ffffff;
  }
  .sokal-link-copy {
    position: relative;
  }
  #videoCardsComponent .video-card {
    position: relative;
    width: 400px;
    height: 600px;
    margin: 10px;
    display: inline-block;
    overflow: hidden;
    border-radius: 12px;
  }

  #videoCardsComponent .video-card .video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  #videoCardsComponent .video-card-overlay {
    position: absolute;
    bottom: 15px;
    left: 15px;
    color: white;
    z-index: 2;
    text-align: left;
  }

  #videoCardsComponent .video-card-title {
    font-family: 'AmericanGroteskCompressed-Black';
    font-size: 6rem;
    text-align: left;
  }

  #videoCardsComponent .sokal-link {
    font-size: 1.75rem;;
  }

  #videoCardsComponent .play-btn {
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translate(-50%, -50%);
    z-index: 3;
    background: rgba(0,0,0,0.5);
    color: white;
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  #videoCardsComponent .play-btn svg {
    width: 24px;
    height: 24px;
    transition: opacity 0.25s ease;
    position: absolute;
  }

  #videoCardsComponent .icon-play {
    opacity: 1;
    margin-left: 5px;
  }

  #videoCardsComponent .icon-pause {
    opacity: 0;
  }

  /* CJDR */
  #videoCardsComponent[data-brand="cjdr"] .video-card-title {
    font-family: "Barlow Condensed", sans-serif;
    font-weight: 700;
    font-style: normal;
    text-transform: uppercase;
    font-size: 5.5rem;
    text-align: left;
  }
  #videoCardsComponent[data-brand="cjdr"] .sokal-link {
    font-size: 1.5rem;
    font-family: "Barlow Condensed", sans-serif;
    font-weight: 700;
    font-style: normal;
    text-transform: uppercase;
  }

  @media (max-width: 575px) {
    #videoCardsComponent .video-card {
      max-width: calc(100% - 15px);
    }
  }
</style>

<style scoped>
  .horizontal-scroll-component {
    --scroll-overlay-gradient-rgba-min: rgba(255, 255, 255, 0);
    --scroll-overlay-gradient-rgba-max: rgba(255, 255, 255, 1);
    --overlay-color-min: var(--scroll-overlay-gradient-rgba-min, rgba(255, 255, 255, 0));
    --overlay-color-max: var(--scroll-overlay-gradient-rgba-max, rgba(255, 255, 255, 1))
  }

  .horizontal-scroll-component {
      overflow: hidden
  }

  .horizontal-scroll-component .scroll-parent {
      position: relative
  }

  .horizontal-scroll-component .scroll-horizontal {
      position: relative;
      background-color: #ffffff;
      overflow-x: scroll;
      width: 100%;
      margin: 0 auto;
      padding: 15px;
      white-space: nowrap;
      -ms-overflow-style: none;
      scrollbar-width: none
  }

  .horizontal-scroll-component .scroll-horizontal::-webkit-scrollbar {
      display: none
  }

  .horizontal-scroll-component .scroll-horizontal>* {
      display: inline-block;
      white-space: normal;
      vertical-align: middle
  }

  .horizontal-scroll-component .scroll-overlay,.horizontal-scroll-component .scroll-nav {
      width: 15%;
      height: 100%;
      position: absolute;
      top: 0;
      z-index: 1;
      -webkit-transition: all 0.1s ease;
      -moz-transition: all 0.1s ease;
      -o-transition: all 0.1s ease;
      transition: all 0.1s ease
  }

  .horizontal-scroll-component .scroll-overlay--left {
      left: -1%;
      background: linear-gradient(to left, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 5%, #fff 100%);
      background: linear-gradient(to left, var(--overlay-color-min) 0%, var(--overlay-color-min) 5%, var(--overlay-color-max, #fff) 100%)
  }

  .horizontal-scroll-component .scroll-overlay--right {
      right: -1%;
      background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 5%, #fff 100%);
      background: linear-gradient(to right, var(--overlay-color-min) 0%, var(--overlay-color-min) 5%, var(--overlay-color-max, #fff) 100%)
  }

  .horizontal-scroll-component .scroll-nav {
      display: flex;
      flex-direction: column;
      justify-content: center
  }

  .horizontal-scroll-component .scroll-nav--right {
      right: 0;
      align-items: flex-end;
      padding-right: 1%
  }

  .horizontal-scroll-component .scroll-nav--left {
      left: 0;
      align-items: flex-start;
      padding-left: 1%
  }

  .horizontal-scroll-component .scroll-nav-btn {
      font-size: inherit;
      font-weight: 300;
      width: 30px;
      height: 30px;
      color: #ffffff;
      background-color: transparent;
      border: solid 2px transparent;
      border-radius: 100%;
      -webkit-transition: all 0.3s ease;
      -moz-transition: all 0.3s ease;
      -o-transition: all 0.3s ease;
      transition: all 0.3s ease;
      background-image: url("https://d2v1gjawtegg5z.cloudfront.net/assets/arrow-right-black-43b6b23ed61b72a8b073b2dfca374fb5ced57d6df7373641f7198deedda943b7.png");
      background-size: 35%;
      background-position: center;
      background-repeat: no-repeat
  }

  .horizontal-scroll-component[data-light-theme="true"] .scroll-nav-btn {
      -webkit-filter: invert(1);
      filter: invert(1)
  }

  .horizontal-scroll-component .scroll-nav--left .scroll-nav-btn {
      transform: rotateY(180deg)
  }

  .horizontal-scroll-component .scroll-nav-btn:hover {
      opacity: 0.7
  }

  .horizontal-scroll-component .scroll-nav-btn:focus,.horizontal-scroll-component .scroll-nav-btn:active {
      color: #ffffff;
      -webkit-transform: scale(1.5);
      transform: scale(1.5)
  }

  .horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:focus,.horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:active {
      -webkit-transform: rotateY(180deg) scale(1.5);
      transform: rotateY(180deg) scale(1.5)
  }

  .horizontal-scroll-component .scroll-parent[data-scroll-region="min"] .scroll-overlay--left,.horizontal-scroll-component .scroll-parent[data-scroll-region="max"] .scroll-overlay--right,.horizontal-scroll-component .scroll-parent[data-scroll-region="min"] .scroll-nav--left,.horizontal-scroll-component .scroll-parent[data-scroll-region="max"] .scroll-nav--right,.horizontal-scroll-component .scroll-parent[data-has-scrollbar="false"] .scroll-overlay,.horizontal-scroll-component .scroll-parent[data-has-scrollbar="false"] .scroll-nav {
      opacity: 0;
      visibility: hidden
  }

  .horizontal-scroll-component .scroll-parent[data-has-scrollbar="false"] .scroll-horizontal {
      text-align: center
  }

  @media (max-width: 767px) {
      .horizontal-scroll-component .scroll-nav-btn:hover,.horizontal-scroll-component .scroll-nav-btn:active,.horizontal-scroll-component .scroll-nav-btn:focus {
          opacity:1;
          color: #ffffff;
          -webkit-transform: scale(1.3);
          transform: scale(1.3)
      }

      .horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:hover,.horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:active,.horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:focus {
          -webkit-transform: rotateY(180deg) scale(1.3);
          transform: rotateY(180deg) scale(1.3)
      }
  }
</style>